<template>
  <div style="background: white; border-bottom: 2px solid #E9F4FF">
    <v-layout justify-center row wrap v-if="isLoggedIn">
      <v-container ma-0 py-0>
        <v-layout justify-center>
          <v-flex xs12 text-xs-right>
            <router-link :to="{ name: 'logout' }">
              Sign out
            </router-link>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <v-layout justify-center row wrap>
      <v-container ma-0 pa-0>
        <v-layout justify-center align-center>
          <v-flex v-if="isLoggedIn">
            <v-toolbar class="white" light flat prominent>
              <div class="logo">
                <div style="height:4px" />
                <router-link :to="{ path: '/' }">
                  <img src="@/assets/logo-banner.png" height="30" class="mr-3">
                </router-link>
              </div>
              <router-link :to="{ path: '/' }">
                <v-btn
                  small
                  flat
                  secondary
                  v-if="$vuetify.breakpoint.mdAndUp"
                >
                  Manipulatives
                </v-btn>
              </router-link>
              <div v-if="!isStudent">
                <v-btn
                  small
                  flat
                  secondary
                  href="https://www.brainingcamp.com/resources"
                  target="_blank"
                  v-if="$vuetify.breakpoint.mdAndUp"
                >
                  Resources
                </v-btn>
              </div>
              <router-link :to="{ path: '/tutorials' }" v-else>
                <v-btn
                  small
                  flat
                  secondary
                  v-if="$vuetify.breakpoint.mdAndUp"
                >
                  Tutorials
                </v-btn>
              </router-link>
              <v-btn
                small
                flat
                secondary
                v-if="!isStudent && $vuetify.breakpoint.lgAndUp"
                href="https://www.brainingcamp.com/webinars"
                target="_blank"
              >
                Webinars
              </v-btn>
              <v-btn
                small
                flat
                secondary
                v-if="!isStudent && $vuetify.breakpoint.mdAndUp"
                href="https://www.brainingcamp.com/pricing"
                target="_blank"
              >
                Pricing
              </v-btn>
              <v-spacer />
              <div v-if="isLoggedIn && $vuetify.breakpoint.smAndUp">
                <ShareCodeEntryControl />
              </div>
              <div v-if="$vuetify.breakpoint.smAndDown">
                <NavMenu/>
              </div>
            </v-toolbar>
          </v-flex>
          <v-flex v-if="!isLoggedIn">
            <v-toolbar class="white" light flat prominent>
              <div class="logo" v-if="$vuetify.breakpoint.smAndUp">
                <div style="height:4px" />
                <router-link :to="{ path: '/' }">
                  <img src="@/assets/logo-banner.png" height="34" class="mr-3">
                </router-link>
              </div>
              <div class="logo" v-if="$vuetify.breakpoint.xsOnly">
                <div style="height:4px" />
                <router-link :to="{ path: '/' }">
                  <img src="@/assets/logo-banner.png" height="28" class="mr-3">
                </router-link>
              </div>
              <router-link :to="{ path: '/' }">
                <v-btn
                  flat
                  secondary
                  v-if="$vuetify.breakpoint.mdAndUp"
                >
                  Manipulatives
                </v-btn>
              </router-link>
              <v-btn
                small
                flat
                secondary
                v-if="!isStudent && $vuetify.breakpoint.mdAndUp"
                href="https://www.brainingcamp.com/pricing"
                target="_blank"
              >
                Pricing
              </v-btn>
              <v-spacer />
              <router-link :to="{ name: 'login' }" v-if="!isLoggedIn && $vuetify.breakpoint.xs">
                <v-btn 
                  color="secondary"
                  depressed
                >
                  <span class="foooter--text">Sign In</span>
                </v-btn>
              </router-link>

              <router-link :to="{ name: 'login' }" v-if="!isLoggedIn && $vuetify.breakpoint.smAndUp">
                <v-btn white flat>
                  <span class="foooter--text">Sign In</span>
                </v-btn>
              </router-link>

              <div v-if="$vuetify.breakpoint.xs">
                <NavMenu/>
              </div>
            </v-toolbar>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
  </div>
</template>

<script>
import ShareCodeEntryControl from '@/components/ShareCodeEntryControl'
import NavMenu from '@/components/NavMenu'

export default {
  components: {
    ShareCodeEntryControl,
    NavMenu
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.token !== null
    },
    isStudent: function () {
      if (this.$store.getters.user) {
        return this.$store.getters.user.role === 'student'
      }
      return false
    }
  }
}
</script>

<style scoped>
.logo {
  cursor: pointer;
}

.lg {
  font-size: 14px;
  color: #56544d;
  font-weight: 500;
  text-transform: uppercase;
}
</style>
